"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportSwitcherTypes = exports.recordCountTableState = exports.recordTypeSwitcherState = exports.tableTileViewSwitcherState = void 0;
const react_1 = __importDefault(require("react"));
const recoil_1 = require("recoil");
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@alcumus/components");
const SingleSelectDropdown_1 = __importDefault(require("./SingleSelectDropdown"));
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    formControl: {
        marginRight: theme.spacing(1),
        minWidth: 143,
    },
    icon: {
        fontSize: components_1.StyleVariables.fonts.size.h1,
    },
}));
const StyledToggleButton = (0, styles_1.withStyles)({
    root: {
        '&$selected': {
            color: components_1.StyleVariables.colors.action.primary.default,
            backgroundColor: components_1.StyleVariables.colors.white,
            '&:hover': {
                backgroundColor: components_1.StyleVariables.colors.grey2,
            },
            '&:active': {
                backgroundColor: components_1.StyleVariables.colors.surface.selected,
            },
        },
        '&:hover': {
            backgroundColor: components_1.StyleVariables.colors.grey2,
        },
        '&:active': {
            backgroundColor: components_1.StyleVariables.colors.surface.selected,
        },
    },
    selected: {},
})(lab_1.ToggleButton);
const StyledGroupButton = (0, styles_1.withStyles)({
    grouped: {
        border: 'none',
        padding: '4px',
    },
})(lab_1.ToggleButtonGroup);
exports.tableTileViewSwitcherState = (0, recoil_1.atom)({
    key: 'tableTileViewSwitcherState',
    default: 'table',
});
exports.recordTypeSwitcherState = (0, recoil_1.atom)({
    key: 'recordTypeSwitcherState',
    default: 'all',
});
exports.recordCountTableState = (0, recoil_1.atom)({
    key: 'recordCountTableState',
    default: 0,
});
var ReportSwitcherTypes;
(function (ReportSwitcherTypes) {
    ReportSwitcherTypes["All"] = "all";
    ReportSwitcherTypes["Looks"] = "looks";
    ReportSwitcherTypes["Folders"] = "folders";
    ReportSwitcherTypes["Dashboards"] = "dashboards";
})(ReportSwitcherTypes || (exports.ReportSwitcherTypes = ReportSwitcherTypes = {}));
function ReportViewToggle({ showCount = true, showDropdown = true, t, }) {
    const [toggle, setToggle] = (0, recoil_1.useRecoilState)(exports.tableTileViewSwitcherState);
    const [type, setType] = (0, recoil_1.useRecoilState)(exports.recordTypeSwitcherState);
    const [count] = (0, recoil_1.useRecoilState)(exports.recordCountTableState);
    const classes = useStyles();
    const handleToggle = (event, newView) => {
        if (newView !== null) {
            setToggle(newView);
        }
    };
    const handleChange = (event) => {
        setType(event.target.value);
    };
    const menuItems = [
        {
            value: ReportSwitcherTypes.All,
            displayName: t('allType', { ns: 'translation' }),
        },
        {
            value: ReportSwitcherTypes.Folders,
            displayName: t('folders', { ns: 'translation' }),
        },
        {
            value: ReportSwitcherTypes.Dashboards,
            displayName: t('dashboards', { ns: 'translation' }),
        },
        {
            value: ReportSwitcherTypes.Looks,
            displayName: t('looks', { ns: 'translation' }),
        },
    ];
    return (react_1.default.createElement(core_1.Grid, { container: true, direction: "row", justifyContent: "space-between", alignItems: "center" },
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center", flexDirection: "column", "data-testid": "resultsCount" }, !!showCount && (react_1.default.createElement(components_1.Text, null,
                count,
                " ",
                t('results', { ns: 'translation' }))))),
        react_1.default.createElement(core_1.Grid, { item: true },
            react_1.default.createElement(core_1.Box, { display: "flex", alignItems: "center", flexDirection: "row" },
                showDropdown && (react_1.default.createElement(SingleSelectDropdown_1.default, { value: type, id: "single-select-dropdown", handleChange: handleChange, formControlClassName: classes.formControl }, menuItems)),
                react_1.default.createElement(StyledGroupButton, { value: toggle, exclusive: true, onChange: handleToggle, "aria-label": t('viewToggle', { ns: 'AriaLabels' }) },
                    react_1.default.createElement(StyledToggleButton, { value: "table", "aria-label": t('tableView', { ns: 'AriaLabels' }), "data-testid": "tableView", disableRipple: true },
                        react_1.default.createElement("span", { className: "material-icons" }, "format_list_bulleted")),
                    react_1.default.createElement(StyledToggleButton, { value: "tile", "aria-label": t('tileView', { ns: 'AriaLabels' }), "data-testid": "tileView", disableRipple: true },
                        react_1.default.createElement("span", { className: "material-icons" }, "grid_view")))))));
}
exports.default = (0, react_i18next_1.withTranslation)(['translation', 'AriaLabels'])(ReportViewToggle);
